export function toNegativeNumber(value: number): number | null {
  console.log('costSummary value', value);

  if (Number.isNaN(value)) {
    return null;
  }

  if (value === 0) {
    return null;
  }

  return value > 0 ? -value : value;
}
